import { computed, defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';
import hoteleImg from '@/assets/realizations/hotele.jpg';
import kulinariaImg from '@/assets/realizations/kulinaria.jpg';
import lokalneImg from '@/assets/realizations/lokalne.jpg';
import modaImg from '@/assets/realizations/moda.jpg';
import outdoorImg from '@/assets/realizations/outdoor.jpg';
import produktoweImg from '@/assets/realizations/produktowe.jpg';
import turystykaImg from '@/assets/realizations/turystyka.jpg';
import RotatingCards from './RotatingCards.vue';
const CARD_IMAGES = [
    hoteleImg,
    turystykaImg,
    kulinariaImg,
    lokalneImg,
    produktoweImg,
    modaImg,
    outdoorImg,
];
export default defineComponent({
    name: 'Realizations',
    components: { RotatingCards },
    setup() {
        const { tm } = useI18n();
        const list = computed(() => tm('realizations.list'));
        const cards = computed(() => {
            const texts = tm('realizations.cards');
            return texts.map((t, i) => ({
                title: t.title,
                subtitle: t.subtitle ?? '',
                image: CARD_IMAGES[i] ?? CARD_IMAGES[0],
            }));
        });
        return { list, cards };
    },
});
